import Installation from './01.installation';
import Domain from './02.domain';

const Y10 = [
    Installation,
    ...Domain
];

export default Y10;